import { connect } from 'react-redux';
import subPage from 'decorators/subPage';
import SubNav from 'components/SubNav';
import UpdateLease from './UpdateLease';
import { withRouter } from 'react-router-dom';
import { getLease } from 'reducers';

const mapStateToProps = (state, props) => {
  const {
    match: {
      params: { leaseId },
    },
  } = props;
  return {
    lease: getLease(state, leaseId),
    leaseId,
    SubNav,
  };
};

export default withRouter(connect(mapStateToProps, null)(subPage(UpdateLease)));
